import { render, staticRenderFns } from "./CampoTramite.vue?vue&type=template&id=109a17e5&"
import script from "./CampoTramite.vue?vue&type=script&lang=js&"
export * from "./CampoTramite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports